import React from 'react';
import { useDebounce } from 'use-debounce';
import { VisuallyHidden } from '../visually-hidden/index.js';
import { useTheme } from '../../hooks/index.js';
import { CharacterCounterElement, CharacterCounterLiveRegion, } from './character-counter.styles.js';
export const CharacterCounter = React.forwardRef(({ maxLength = 0, message, value = '', 'aria-live': ariaLive = 'polite', liveTextDebounceTime, elementType = 'p', ...rest }, ref) => {
    const remainingCount = Math.max(0, maxLength - value.length);
    const theme = useTheme();
    const text = message(remainingCount);
    const [announcedText] = useDebounce(text, theme.debounceTime[liveTextDebounceTime || 'standard']);
    return (React.createElement(React.Fragment, null,
        React.createElement(CharacterCounterElement, { "aria-hidden": true, ref: ref, elementType: elementType, ...rest }, text),
        React.createElement(VisuallyHidden, { elementType: 'span' },
            React.createElement(CharacterCounterLiveRegion, { "aria-live": ariaLive }, announcedText))));
});
//# sourceMappingURL=character-counter.component.js.map